<template>
  <header class="c-header-header-desktop">
    <div class="c-header-header-desktop__inner" ref="inner">
      <h1 v-if="renderH1" class="c-header-header-desktop__h1">
        家具・インテリア雑貨ならFrancfranc（フランフラン）
      </h1>
      <a class="c-header-header-desktop__logo" :href="routes.root">
        <img
          :src="logoUrl"
          alt="Francfranc online"
          width="167"
          height="40"
          loading="lazy"
        />
      </a>
      <div class="c-header-header-desktop__search">
        <search-input
          color="gray"
          :value="searchKeyword"
          :placeholder="placeholder"
          @search-keyword-input="$emit('search-keyword-input', $event)"
          @search-input-entered="$emit('search-input-entered', $event)"
          @search-input-focused="$emit('search-input-focused')"
        ></search-input>
      </div>

      <nav>
        <ul class="c-header-header-desktop__menu">
          <li v-if="accountName" class="c-header-header-desktop__menu-item">
            <icon-button
              icon-name="man"
              :text="`${accountName}さま`"
              :href="routes.mypage"
            ></icon-button>
          </li>

          <li v-else class="c-header-header-desktop__menu-item">
            <icon-button
              icon-name="man"
              text="ログイン"
              :href="routes.login"
            ></icon-button>
          </li>

          <li class="c-header-header-desktop__menu-item">
            <icon-button
              icon-name="heart-outline"
              text="お気に入り"
              :href="routes.fav"
            ></icon-button>
          </li>

          <li class="c-header-header-desktop__menu-item">
            <button-cart
              :href="routes.cart"
              :cart-count="cartCount"
              show-text
            ></button-cart>
          </li>

          <li class="c-header-header-desktop__menu-item">
            <icon-button
              class="js-ignore-click-event"
              icon-name="menu"
              text="MENU"
              type="button"
              @icon-button-mouseenter="$emit('menu-icon-mouseenter')"
            ></icon-button>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import ButtonCart from '~/js/components/header/buttonCart'
import IconButton from '~/js/components/header/iconButton'
import SearchInput from '~/js/components/header/searchInput'
export default {
  name: 'ComponentHeaderHeaderDesktop',
  components: {
    ButtonCart,
    IconButton,
    SearchInput,
  },
  props: {
    accountName: { type: String, default: '' },
    cartCount: { type: Number, default: 0 },
    logoUrl: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    searchKeyword: { type: String, default: '' },
    renderH1: { type: Boolean, default: false },
    routes: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  mounted() {
    const height = this.$refs.inner.clientHeight
    const width = this.$refs.inner.clientWidth
    this.$emit('header-mounted', { height, width })
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';

.c-header-header-desktop {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background-color: #fff;

  &__h1 {
    color: variables.$color-brown;
    font-weight: 300;
    font-size: 10px;
    margin-bottom: 4px;
    width: 100%;
  }

  &__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: auto;
    padding: 28px variables.$padding-side-desktop;
    max-width: variables.$width-section-wide;
  }

  &__logo {
    flex-shrink: 0;
  }

  &__search {
    flex-grow: 1;
    margin: 0 60px;
  }

  &__menu {
    display: flex;
  }

  &__menu-item {
    margin: 0 4px;
    padding: 5px;
    width: 60px;
  }
}
</style>
